<template>
  <b-modal :visible="modalShow || visible" centered hide-header hide-footer no-close-on-backdrop>
    <div class="d-block text-center modal-container">
      <div class="content-subject">{{ $t('error.failedToProcess') }}</div>
      <div class="content-desc">{{ $t('selfcheck.selfcheckRestartApology') }}</div>
      <div class="buttons">
        <so-button @click="$emit('backtotop')">{{ $t('selfcheck.backToMainMenu') }}</so-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SoButton from '@/components/common/SoButton'

export default {
  components: {
    SoButton,
  },
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      modalShow: 'modal/isShowingSelfcheckUnhandledErrorModal',
    }),
  },
  methods: {
    ...mapActions({
      cancelSelfcheck: 'selfcheck/cancelSelfcheck',
      setShowingSelfcheckErrorModal: 'modal/setShowingSelfcheckErrorModal',
      setShowingSimpleErrorModal: 'modal/setShowingSimpleErrorModal',
    }),
    async handleBackToTop() {
      await this.cancelSelfcheck({ callStaff: false })
      console.log(this.error)

      if (this.error) {
        if (this.error.response) {
          this.setShowingSelfcheckErrorModal(true)
          this.$router.replace({ name: 'shopMenu' })
        } else {
          this.setShowingSimpleErrorModal(true)
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-container {
  padding-top: 8px;
  padding-bottom: 8px;
}
.content {
  color: #222222;
  &-subject {
    font-size: 18px;
    font-weight: bold;
  }
  &-desc {
    text-align: start;
    padding: 20px 0;
    font-size: 14px;
  }
}
.buttons {
  width: 100%;
  display: flex;
  justify-content: center;
}
.button-quit {
  background: #d21b24 !important;
  width: 240px;
  height: 40px;
  border: none;
  font-weight: bold;

  &:hover,
  &:active {
    background-color: #d21b24 !important;
  }

  img {
    width: 18px;
    height: 18px;
    color: #fff;
    margin: -5px 8px 0 0;
  }
}
.content-desc {
  white-space: pre-wrap;
}
</style>
